export default __webpack_public_path__ + "static/media/bleedingpuncture3.1e8ba1e1.png";